import React from "react"
import { Menu as MenuPrimitive } from "@base-ui/react/menu"

export type MenuDividerProps = Record<string, never>

const dividerStyles = "my-1 -mx-1 h-px bg-gray-200"

export function MenuDivider() {
  return <MenuPrimitive.Separator data-slot="menu-divider" className={dividerStyles} />
}

MenuDivider.displayName = "Menu.Divider"
